import { glassSurface } from './glassStyles';

export const surfaceCard = (theme) => ({
	...glassSurface(theme, 'medium'),
	borderRadius: '20px',
});
